
import { API_APP_URL } from "../../constants/app";
const headerConfig = {
        Accept: "*/*",
		"Content-Type": "application/json",
}
export async function getProvinceScanDropDown(payload) {
  let res = await fetch(`${API_APP_URL}/dropdown/province/list`, {
    method: "POST",
    headers: headerConfig,
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: payload.isKh? val.nameKh: val.nameEn,
        });
      });
      return modifiedData;
    });
  return res;
}


export async function getPurposeOfVisitScanDropDown(payload) {
  let res = await fetch(`${API_APP_URL}/dropdown/purpose-of-visit/list`, {
    method: "POST",
    headers: headerConfig,
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: payload.isKh? val.nameKh: val.nameEn,
        });
      });
      return modifiedData;
    });
  return res;
}

export async function getDurationOfVisitScanDropDown(payload) {
  let res = await fetch(`${API_APP_URL}/dropdown/duration/list`, {
    method: "POST",
    headers: headerConfig,
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: payload.isKh? val.nameKh: val.nameEn,
        });
      });
      return modifiedData;
    });
  return res;
}

export async function getTransportationScanDown(payload) {
  let res = await fetch(`${API_APP_URL}/dropdown/transportation/list`, {
    method: "POST",
    headers: headerConfig,
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((val) => {
        modifiedData.push({
          value: val.id,
          label: payload.isKh? val.nameKh: val.nameEn,
        });
      });
      return modifiedData;
    });
  return res;
}

export async function addFormScan(payload) {
  let res = await fetch(`${API_APP_URL}/scan/add`, {
    method: "POST",
    headers: headerConfig,
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
  return res;
}
